import { CircularProgress, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        "& .MuiCircularProgress-root": {
            marginBottom: theme.spacing(1.5),
            width: "30px !important",
            height: "30px !important"
        }
    }
}));

const PageLoader = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CircularProgress/>
            <Typography variant="body2">
                Please wait...
            </Typography>
        </div>
    )
}

export default PageLoader